import { createScopedLogger } from 'pi-kiosk-shared/logging';
import { customerLogger } from '../../shared/logging/customerLogger.js';

export const rewardsLog = createScopedLogger(customerLogger, { module: 'promo', feature: 'rewards' });
